import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=4b33a65b&scoped=true"
import script from "./FilesTable.vue?vue&type=script&lang=ts"
export * from "./FilesTable.vue?vue&type=script&lang=ts"
import style0 from "./FilesTable.scss?vue&type=style&index=0&id=4b33a65b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33a65b",
  null
  
)

export default component.exports